import { type ReactNode, useInsertionEffect } from "react"

import {
  installColorScheme,
  installTheme,
  uninstallColorScheme,
  uninstallTheme,
} from "../theme/install"

export interface ThemeProviderProps {
  children?: ReactNode
  mode?: "light" | "dark" | "system"
}

export function ThemeProvider(props: ThemeProviderProps) {
  const { children, mode = "system" } = props

  useInsertionEffect(() => {
    installTheme(document.body)
    return () => uninstallTheme(document.body)
  }, [])

  useInsertionEffect(() => {
    if (mode === "dark" || mode === "light") {
      installColorScheme(document.body, mode)
      return () => uninstallColorScheme(document.body)
    }

    function onMediaQueryChange(event: MediaQueryListEvent) {
      replaceModeClass(event.matches)
    }

    function replaceModeClass(matches: boolean) {
      uninstallColorScheme(document.body)
      installColorScheme(document.body, matches ? "dark" : "light")
    }

    const mediaQueryList = window.matchMedia("(prefers-color-scheme: dark)")
    replaceModeClass(mediaQueryList.matches)
    mediaQueryList.addEventListener("change", onMediaQueryChange)

    return () => {
      mediaQueryList.removeEventListener("change", onMediaQueryChange)
      uninstallColorScheme(document.body)
    }
  }, [mode])

  return <>{children}</>
}
